import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { CofidisCaseEdit } from './CofidisCaseEdit';
import { CofidisCaseEditGeneral } from './CofidisCaseEditGeneral';
import { CofidisCaseEditCredits } from './CofidisCaseEditCredits';

export const CofidisCaseEditWrapper = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const editType = searchParams.get('editType');

  // Route to different edit components based on editType parameter
  switch (editType) {
    case 'general':
      return <CofidisCaseEditGeneral {...props} />;
    case 'credits':
      return <CofidisCaseEditCredits {...props} />;
    default:
      return <CofidisCaseEdit {...props} />;
  }
};







